import AxiosControl from '../../context/axios/AxiosControl'

const Axios = AxiosControl()

export const getActivePassesForTicketPurchase = (params) => async (dispatch) => {
    dispatch({ type: 'PASS_DISCOUNT_LOADING' })

    try {
        const { data, status } = await Axios.post('/api/pass/getActivePassesForTicketPurchase', params)

        if (status === 200) {
            dispatch({
                type: 'PASS_DISCOUNT_SEARCH_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'PASS_DISCOUNT_ERROR',
                payload: 'No se pudieron cargar los abonos'
            })
        }
    } catch (error) {
        dispatch({
            type: 'PASS_DISCOUNT_ERROR',
            payload: error.response?.data?.message || 'Error al buscar abonos'
        })
    }
}

export const resetPassDiscountSearch = () => async (dispatch) => {
    dispatch({ type: 'PASS_DISCOUNT_RESET' })
}

